import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { msg } from '@lingui/core/macro';
import { currencyField } from './common/expenditureFields';
import { incidentIdField } from './common/sharedFields';

export const antiBriberyAndCorruptionIncidentsMetadata = {
  displayName: msg({
    message: 'Bribery and corruption',
    context: 'Activity data schema name for bribery and corruption incidents',
  }),
  fields: {
    ...coreFields,
    conviction_date: {
      displayName: msg({
        message: 'Conviction date',
        context: 'The display name for a dimension',
      }),
    },
    currency: currencyField,
    currency_quantity: {
      displayName: msg({
        message: 'Anti-bribery and corruption monetary remediation spend',
        context: 'The display name for a metric',
      }),
    },
    has_conviction: {
      displayName: msg({
        message: 'Has conviction',
        context: 'The display name for a dimension',
      }),
    },
    incident_id: incidentIdField,
    was_own_workers_dismissed: {
      displayName: msg({
        message: 'Was own workers dismissed',
        context: 'The display name for a dimension',
      }),
    },
    was_related_to_contracts_that_were_negatively_affected: {
      displayName: msg({
        message: 'Was related to contracts that were negatively affected',
        context: 'The display name for a dimension',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
